import { useState } from "react";
import { Center } from '@chakra-ui/react'
import onboardingDoc from 'assets/images/svgs/onboarding-doc.svg'
import history from "infra/helpers/history";
import ModalContaBancaria from "ui/components/Features/ContaBancaria/ModalContaBancaria"
import { showSuccess } from "infra/helpers/alerta";
import CardOnboarding from "../components/card-onboarding";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function QuartoPasso() {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const { tenant } = useCurrentTenant();

    return(
        <Center w="100vw" h="100vh">
            <CardOnboarding 
                imageSrc={ onboardingDoc }
                headingText="Contas"
                subheadText="Adicione as contas bancárias de seu condomínio e fique por dentro das movimentações e conciliações bancárias."
                onNext={() => setIsOpenModal(true)}
                onBack={() => history.push('quinto-passo')}
                onNextText="ADICIONAR UMA CONTA"
                onBackText="AGORA NÃO"
                onPular={ true }
                step={4}
            />
            {isOpenModal ? (
                <ModalContaBancaria
                    isOpenModal={isOpenModal}
                    onClose={() => setIsOpenModal(false)}
                    tenantId={tenant.id}
                    onSuccess={async () => {
                        showSuccess();               
                        setIsOpenModal(false);
                        history.push('quinto-passo');
                    }}
                />
            ) : null}
        </Center>        
    )
}

export default QuartoPasso;